import ContentSection, { ContentSectionFooterButton, ContentSectionHeader, ContentSectionHeaderLink } from '@/components/ContentSection';
import styles from './styles/HeadlinesModule.module.scss';
import Link from 'components/Link';
import Image from 'components/Image';
import DateString from 'components/DateString';

export default function HeadlinesModule({
  title = 'Top Headlines',
  href,
  articles
}: {
  title?: string;
  href?: string;
  articles: {
    id: string;
    date: string;
    authorName: string;
    imageAlt?: string;
    imageUrl?: string;
    path: string;
    title: string;
  }[];
}) {
  return (
    <ContentSection>
      <ContentSectionHeader right={href && <ContentSectionHeaderLink href={href}>All News</ContentSectionHeaderLink>}>
        {title}
      </ContentSectionHeader>
      <div className={styles.Articles}>
        {articles.map(article => (
          <Link href={article.path} className={styles.Article} key={article.id}>
            <div className={styles.ArticleImageContainer}>
              <Image src={article.imageUrl} alt={article.imageAlt || article.title} className={styles.ArticleImage} />
            </div>
            <div className={styles.ArticleInfo}>
              <div className={styles.ArticleTitle}>{article.title}</div>
              <div className={styles.AuthorBlock}>
                <div className={styles.AuthorName}>{article.authorName}</div>
                <div className={styles.AuthorDot} />
                <div className={styles.ArticleDate}>
                  <DateString date={article.date} short />
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
      {href && <ContentSectionFooterButton href={href}>All News</ContentSectionFooterButton>}
    </ContentSection>
  );
}
